export default "__VITE_ASSET__559522de__"